// Configurações padrão para produção
export const DEFAULT_CONFIG = {
  API_URL: 'https://api.snapness.com.br/api',
  GOOGLE_CLIENT_ID: '1046979574658-m63o62n8d49alobm5luv8pt4eiqg6vu3.apps.googleusercontent.com'
};

// Função para obter configuração com fallback
export const getConfig = () => {
  return {
    API_URL: import.meta.env.VITE_API_URL || DEFAULT_CONFIG.API_URL,
    GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || DEFAULT_CONFIG.GOOGLE_CLIENT_ID
  };
}; 